var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.163 7.525H18V5.331c0-.527-.409-.956-.91-.956H8.837l-1.666-2.45H.91c-.502 0-.911.43-.911.956v15.29h.002a.92.92 0 00.174.552c.163.224.41.352.679.352h14.92a.853.853 0 00.816-.634L20 8.627v-.062c0-.602-.352-1.04-.837-1.04zM.667 2.881a.25.25 0 01.244-.256h5.917l1.667 2.45h8.594a.25.25 0 01.244.256v2.194H4.243a.855.855 0 00-.816.634l-2.76 7.906V2.88zm15.29 15.348a.19.19 0 01-.182.146H.855a.182.182 0 01-.15-.078c-.02-.028-.053-.09-.04-.143l3.397-9.783a.19.19 0 01.181-.146h14.92c.127 0 .16.191.168.287l-3.375 9.717z",
    fill: "#3555F0"
  })));
}

export default __webpack_public_path__ + "./fonts/open-folder.94c646ce7985b4ced81fe56cbe9725a6.svg";
export { SvgOpenFolder as ReactComponent };